import axios from "axios";
import { UserManager, WebStorageStateStore, Log } from "oidc-client";
import presitentStore from "../store";

const api = axios.create({
  baseURL: process.env.REACT_APP_REQUEST_CONTACT,
});
const forgotPasswordErrorCode = "AADB2C90118";
const tenantId = "318d0e4f-4e7b-4b80-bc36-208b0c8e41ca";
const client_id = "946b0049-41f5-4d75-8d6d-67b094e694e1";
const signInFlow = "B2C_1_sign_in";
const resetFlow = "b2c_1_reset";

const orgName = "giforg";
const homePage = process.env.REACT_APP_HOMEPAGE;
// const signInAuthority = `https://${orgName}.b2clogin.com/${tenantId}/B2C_1_sign_in`;
const authority = `https://${orgName}.b2clogin.com/${tenantId}/B2C_1_sign_in`;

const createSettings = (flowname) => ({
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  //authority: `https://${orgName}.b2clogin.com/${tenantId}/${flowname}`,
  authority,
  redirect_uri: `${homePage}signin-oidc`,
  post_logout_redirect_uri: `${homePage}logout/callback`,
  response_type: "id_token",
  response_mode: "query",
  filterProtocolClaims: true,
  scope: "openid profile",
  //scope: `https://${orgName}.b2clogin.com/tfp/${tenantId}/${flowname} openid profile`,

  client_id,
  // automaticSilentRenew: true,
  loadUserInfo: true,
  // accessTokenExpiringNotificationTime: 240,
  silent_redirect_uri: `${homePage}silentrenew`,

  metadata: {
    issuer: `https://${orgName}.b2clogin.com/${tenantId}/v2.0/`,
    authorization_endpoint: `https://${orgName}.b2clogin.com/${orgName}.onmicrosoft.com/oauth2/v2.0/authorize?p=${flowname}`,
    token_endpoint: `https://${orgName}.b2clogin.com/${orgName}.onmicrosoft.com/oauth2/v2.0/token?p=${flowname}`,
    end_session_endpoint: `https://${orgName}.b2clogin.com/${orgName}.onmicrosoft.com/oauth2/v2.0/logout?p=${flowname}`,
    jwks_uri: `https://${orgName}.b2clogin.com/${orgName}.onmicrosoft.com/discovery/v2.0/keys?p=${flowname}`,
  },
});

function parseJwt(token) {
  if (!token) return null;

  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

class AuthService {
  constructor() {
    this.UserManager = new UserManager(createSettings(signInFlow));
    // Logger
    Log.logger = console;
    Log.level = Log.WARN;
    this.UserManager.events.addUserLoaded((user) => {
      const { exp } = parseJwt(user.id_token);
      sessionStorage.setItem(`oidc.exp:${authority}:${client_id}`, exp);
      if (window.location.href.indexOf("signin-oidc") !== -1) {
        debugger;
        this.singedIn();
      }
    });
    this.UserManager.events.addAccessTokenExpiring(function () {
      console.log("token expiring...");
      debugger;
    });
    this.UserManager.events.addSilentRenewError((e) => {
      debugger;
      console.log("silent renew error", e.message);
    });

    this.UserManager.events.addAccessTokenExpired(() => {
      console.log("token expired");
      debugger;
      this.signinSilent();
    });
  }
  getPortals = async () => {
    const user = await this.getUser();
    const {
      id_token,
      profile: {
        emails: [email],
      },
    } = user;

    const { data } = await api.get("contact/getPortals", {
      headers: {
        Authorization: `Bearer ${id_token}`,
        X_USER_EMAIL: email,
      },
    });
    return data;
  };
  signinRedirectCallback = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const error_description = urlParams.get("error_description");
    if (!error_description) {
      this.UserManager.signinRedirectCallback().catch((error) => {
        if (error.message === "No state in response") {
          this.UserManager.signinSilent()
            .then(() => {
              this.singedIn();
            })
            .catch((error) => {
              console.error(error);
              window.location.href = "./";
            });
        }
      });
      return;
    }

    if (error_description?.includes(forgotPasswordErrorCode)) {
      const resetConfig = createSettings(resetFlow);
      const resetManager = new UserManager(resetConfig);
      resetManager.signinRedirect({});
      return;
    }
    this.singedIn();
  };

  getUser = async () => {
    const user = await this.UserManager.getUser();
    if (!user) {
      return await this.UserManager.signinRedirectCallback().catch((error) => {
        if (error.message === "No state in response");
        this.UserManager.signinSilent();
      });
    }
    return user;
  };

  parseJwt = (token) => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace("-", "+").replace("_", "/");
    return JSON.parse(window.atob(base64));
  };

  signinRedirect = (redirectUri) => {
    if (redirectUri) {
      localStorage.setItem("redirectUri", redirectUri);
    } else {
      localStorage.setItem("redirectUri", window.location.pathname);
    }
    this.UserManager.signinRedirect({});
  };

  singedIn = async () => {
    if (this.isAuthenticated()) {
      const user = await this.getUser();
      const {
        id_token,
        profile: {
          emails: [email],
        },
      } = user;

      const headers = {
        Authorization: `Bearer ${id_token}`,
        X_USER_EMAIL: email,
      };

      const contactPromise = api.get("contact/get", { headers });
      const termsPromise = api.get("contact/gettermsagreed", { headers });
      const proposalsPromise = api.get("proposal/getall", { headers });

      const [contact,terms,proposals] = await Promise.all([
        contactPromise,
        termsPromise,
        proposalsPromise,
      ]);

       presitentStore.store.dispatch({
         type: "user/setProposals",
         payload: proposals.data,
       });
       presitentStore.store.dispatch({
         type: "user/setContact",
         payload: contact.data,
       });
      presitentStore.store.dispatch({
        type: "user/setUser",
        payload: user.profile,
      });

      if (!terms.data) {
        window.location.replace("/terms");
        return;
      }
    }
    const redirect_uri = localStorage.getItem("redirectUri") || "/";
    localStorage.removeItem("redirectUri");
    window.location.replace(redirect_uri);
  };

  isAuthenticated = () => {
    const oidcStorage = JSON.parse(
      sessionStorage.getItem(`oidc.user:${authority}:${client_id}`)
    );
    return !!oidcStorage && !!oidcStorage.id_token;
  };

  getExp = () => {
    return sessionStorage.getItem(`oidc.exp:${authority}:${client_id}`);
  };
  signinSilent = async () => {
    return this.UserManager.signinSilent();
  };
  signinSilentCallback = () => {
    this.UserManager.signinSilentCallback().catch(() => {
      this.signinRedirect();
    });
  };

  createSigninRequest = () => {
    return this.UserManager.createSigninRequest();
  };

  logout = async () => {
    const user = await this.getUser();
    const {
      id_token,
      profile: {
        emails: [email],
      },
    } = user;

    const headers = {
      Authorization: `Bearer ${id_token}`,
      X_USER_EMAIL: email,
    };

    // burning the token
    
    this.UserManager.signoutRedirect({
      id_token_hint: localStorage.getItem("id_token"),
    });
    
    sessionStorage.removeItem(`oidc.exp:${authority}:${client_id}`);
    this.UserManager.clearStaleState();
    await api.get("contact/logout", { headers });
  };

  signoutRedirectCallback = () => {
    this.UserManager.signoutRedirectCallback().then(() => {
      localStorage.clear();
      window.location.replace("/");
    });
    this.UserManager.clearStaleState();
  };
}

export default new AuthService();
